<template>
   <div>
       <HeadDetailsGama :titleHead="'Detalhe consulta de comissões'"></HeadDetailsGama>
        <p  class="ml-3 pt-3 subtitle">Parcelas da Comissão</p>

              <Tables ref="tableGridParcela"
              :columns="headTable"
              :showSearch="false"
              :showPrint="false"
              :showHeader="false"
              :showPaging="false"
              :showDownload="false"
              :showFullscreen="false"
              :showClickToSelect="false"
              v-on:Load="onLoad"
            >
              <tr v-for="parcela in consultaparcela" v-bind:key="parcela.id">
                <TableColumn :IsText="true"    :status="1" :value="parcela.valorParcelaFormatada" />
                <TableColumn :IsText="true"    :status="1" :value="parcela.dataVencimentoFormatada" />
                <TableColumn :newState="true"  :newStatusNumber="parcela.status" :descriptionNewStatus="['Quitado','Vencido', 'A Receber'][parcela.status]" />
              </tr>
            </Tables>
   </div>
</template>

<script>
import CommissionSales from './commissionsales'
export default CommissionSales
</script>

<style scoped>

.subtitle{
  font-size: 18px;
  color: #008148;
  font-weight: bold;
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/salesinquiry/components/commissionsales/commissionsales.vue